import type { Store } from 'vuex';
import { currentJwt } from '@/lib/jwt';

/**
 * Loads account into Vuex when missing so route guards and chrome (nav) can rely on store account.
 * Runs on skipAuth routes too, so a signed-in visitor still gets the signed-in header.
 * No-ops when there is no JWT or account is already loaded.
 */
export async function ensureAccountLoadedOnce(store: Store<unknown>): Promise<void> {
  if (!currentJwt()) {
    return;
  }

  if (store.getters['account/getAccount']) {
    return;
  }

  try {
    await store.dispatch('account/fetchAccountData');
  } catch (error) {
    console.error('Failed to fetch account data during navigation:', error);
  }
}
